export enum Roles {
  ADMIN = 'mobile-app-admin',
}
